namespace Areas.Vendor.Events {
    "use strict";


    export function uploadFile(eventId: number) {
        return (e) => {
            const parameters = {
                eventId: eventId
            }

            const eventFileUploadDialog = new Areas.Dialogs.EventFileUpload.EventFileUploadDialog(() => { }, parameters);
        }
    }


}